import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { configActions } from "../../../../redux/actions";

function SaveCustomerConfirm({
  translate,
  dispatch,
  modalConfirm,
  confirmDialogHandler,
  isNewCustomer,
  selectedCustomerInfo,

  showLoader,
  hideLoader,
  handleSelectCustomer,
  saveCustomer,
}) {
  const toggleModalConfirm = () => {
    dispatch(configActions.toggleModalConfirm(!modalConfirm));
  };
  const handleCancelDialog = () => {
    toggleModalConfirm();
  };
  const handleDiscardDialog = () => {
    if (confirmDialogHandler) {
      confirmDialogHandler();
    } else {
      if (!isNewCustomer) {
        if (selectedCustomerInfo) {
          handleSelectCustomer(
            { globalId: selectedCustomerInfo.GlobalId },
            true,
            true
          );
          showLoader("Loading customers...");
          dispatch(configActions.getAllCustomers()).then(() => hideLoader());
        }
      }
      toggleModalConfirm();
    }
  };

  const handleSaveDialog = () => {
    saveCustomer(confirmDialogHandler);
  };

  return (
    <Modal isOpen={modalConfirm} toggle={toggleModalConfirm}>
      <ModalHeader toggle={toggleModalConfirm}>
        {translate("SavingChanges")}
      </ModalHeader>
      <ModalBody>{translate("SavingChangesConfirmMsg")}</ModalBody>
      <ModalFooter className="text-center">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelDialog}
        >
          {translate("Cancel")}
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleDiscardDialog}
        >
          {translate("Discard")}
        </button>
        <Button
          color="primary"
          className="EventSearchSubmit"
          style={{ marginLeft: "60px" }}
          onClick={handleSaveDialog}
        >
          {translate("SaveChanges")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

function mapStateToProps(state) {
  const {
    locale,
    config: {
      modalConfirm,
      confirmDialogHandler,
      isNewCustomer,
      selectedCustomerInfo,
    },
  } = state;
  return {
    modalConfirm,
    confirmDialogHandler,
    isNewCustomer,
    selectedCustomerInfo,
    translate: getTranslate(locale),
  };
}

const connectedSaveCustomerConfirm =
  connect(mapStateToProps)(SaveCustomerConfirm);
export { connectedSaveCustomerConfirm as SaveCustomerConfirm };
